@if (isCreate()) {
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item active" aria-current="page">
        <a [routerLink]="'/configuration/offers'">Offers</a>
      </li>
      <li class="breadcrumb-item" aria-current="page">
        <span class="fs-5 fw-bold mb-0">Add offer</span>
      </li>
    </ol>
  </nav>
}

@if (loaded) {
  <div class="card border-0 shadow mb-3 fade-in-zoom">
    @if (!isCreate()) {
      <div
        class="card-header fw-bold bg-tertiary p-3 border-0 d-flex justify-content-between align-items-center">
        <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-gift me-2 text-primary"></i>Offer</h2>
      </div>
    }
    <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="row g-3 mb-3">
          <div class="col">
            <label class="form-label">Target Account Type</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-people"></i></span>
              <select class="form-select" id="accountType" formControlName="targetAccountType">
                <option [ngValue]="null">All</option>
                @for (accountType of partnerAccountTypeList; track accountType) {
                  <option [value]="accountType">{{ 'partnerAccountType.' + accountType | translate }}</option>
                }
              </select>
            </div>
          </div>
          <div class="col">
            <label for="product" class="form-label">Brand</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-box"></i></span>
              <select id="product" class="form-select" formControlName="productId">
                <option [ngValue]="null" disabled>Select product</option>
                @for (product of products; track product) {
                  <option [ngValue]="product.id">{{ product }}</option>
                }
              </select>
            </div>
          </div>
          <div class="col">
            <label class="form-label">Name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi bi-tag"></i></span>
              <input type="text" class="form-control" placeholder="Name" formControlName="name">
            </div>
          </div>
          @if (isAffiliate()) {
            <div class="col">
              <label for="conversionType" class="form-label">Conversion Type</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-arrow-repeat"></i></span>
                <select id="conversionType" class="form-select" formControlName="conversionType">
                  @for (conversionType of conversionTypeList; track conversionType) {
                    <option
                      [ngValue]="conversionType">{{ ('conversionType.' + conversionType) | translate }}
                    </option>
                  }
                </select>
              </div>
            </div>
          }
        </div>
        <div class="row g-3 mb-3">
          <div class="col-6">
            <label for="descriptionHtml" class="form-label">Description (HTML)</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-code-slash"></i></span>
              <textarea id="descriptionHtml" class="form-control" rows="3" placeholder="HTML description"
              formControlName="descriptionHtml"></textarea>
            </div>
          </div>
          <div class="col-6">
            <label for="descriptionText" class="form-label">Description (Text)</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-text-left"></i></span>
              <textarea id="descriptionText" class="form-control" rows="3"
              placeholder="Plain text description" formControlName="descriptionText"></textarea>
            </div>
          </div>
        </div>
        <div class="row g-3 mb-3">
          <div class="col">
            <label for="previewUrl" class="form-label">Preview URL</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="url" class="form-control" id="previewUrl" placeholder="Enter preview URL"
                formControlName="previewUrl">
            </div>
          </div>
          <div class="col">
            <label for="defaultUrl" class="form-label">Default URL</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="url" class="form-control" id="defaultUrl" placeholder="Enter default URL"
                formControlName="defaultUrl">
            </div>
          </div>
        </div>
        @if (isAffiliate()) {
          <div class="row g-3 mb-3">
            <div class="col-auto">
              <label for="currency" class="form-label">Currency</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-currency-exchange"></i></span>
                <select id="currency" class="form-select" formControlName="currencyId">
                  @for (currency of currencies; track currency) {
                    <option [ngValue]="currency.id">{{ currency }}</option>
                  }
                </select>
              </div>
            </div>
            <div class="col">
              <label class="form-label">GEO groups</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-geo-alt"></i></span>
                <select [(ngModel)]="geoGroups" (change)="selectGeoGroup()" [ngModelOptions]="{standalone: true}" class="form-select">
                  <option [ngValue]="null">Select a GEO group</option>
                  @for (geoGroup of getGeoGroups(); track geoGroup) {
                    <option [ngValue]="geoGroup.value">{{ geoGroup.label }}</option>
                  }
                </select>
              </div>
            </div>
            <div class="col">
              <label class="form-label">GEO(s)</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-geo-alt"></i></span>
                <app-dropdown-select (change)="resetGeoGroups()" [multiple]="true" formControlName="countries">
                  @for (country of countries; track country) {
                    <app-dropdown-select-option [value]="country.isoCode">
                      <img [ngSrc]="countryService.getFlag(country.isoCode)" [alt]="country.name" class="country-flag" width="24" height="24">
                      {{ country.name }}
                    </app-dropdown-select-option>
                  }
                </app-dropdown-select>
              </div>
            </div>
            <div class="col-auto">
              <label class="form-label small fw-bold">Behavior if GEO is forbidden</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-grid"></i></span>
                <select formControlName="blockTraffic" class="form-select">
                  <option [ngValue]="false">Redirect traffic to internal offer</option>
                  <option [ngValue]="true">Block traffic</option>
                </select>
              </div>
            </div>
            <div class="col">
              <label class="form-label small fw-bold">Verticals</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-grid"></i></span>
                <app-dropdown-select [multiple]="true" formControlName="verticals" placeholder="Verticals">
                  @for (vertical of verticalList; track vertical) {
                    <app-dropdown-select-option
                      [value]="vertical.id">{{ ('vertical.' + vertical.identifier) | translate }}
                    </app-dropdown-select-option>
                  }
                </app-dropdown-select>
              </div>
            </div>
          </div>
        }
        @if (isAffiliate()) {
          <div class="row g-3 mb-3">
            <div class="col">
              <label class="form-label">Private</label>
              <app-input-switch id="private" formControlName="private">Enabled</app-input-switch>
            </div>
            <div class="col">
              <label class="form-label">Require Approval</label>
              <app-input-switch id="requireApproval" formControlName="requireApproval">Enabled</app-input-switch>
            </div>
          </div>
        }
        <div class="row g-3 mb-3 not-implemented">
          <div class="col-6">
            <label for="tc" class="form-label">T&amp;C</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-file-earmark-text"></i></span>
              <select id="tc" class="form-select">
                <option value="yes">Yes</option>
                <option value="no" selected="">No</option>
              </select>
            </div>
            <div id="tcBlock" class="w-100 d-none mt-3">
              <label for="termsConditions" class="form-label">Terms &amp; Conditions</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-file-earmark"></i></span>
                <textarea id="termsConditions" class="form-control" rows="3" placeholder="Enter T&amp;C"></textarea>
              </div>
            </div>
          </div>
          <div class="col-6">
            <label for="cap" class="form-label">CAP</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-bar-chart"></i></span>
              <select id="cap" class="form-select">
                <option value="yes">Yes</option>
                <option value="no" selected="">No</option>
              </select>
            </div>
            <!--          <div class="row d-none mt-3">-->
            <!--            <div class="col">-->
            <!--              <label for="dailyCap" class="form-label">Daily Cap</label>-->
            <!--              <div class="input-group">-->
            <!--                <span class="input-group-text"><i class="bi bi-calendar-event"></i></span>-->
            <!--                <input type="number" class="form-control" id="dailyCap" placeholder="Enter daily cap">-->
          <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="col">-->
        <!--              <label for="monthlyCap" class="form-label">Monthly Cap</label>-->
        <!--              <div class="input-group">-->
        <!--                <span class="input-group-text"><i class="bi bi-calendar-month"></i></span>-->
        <!--                <input type="number" class="form-control" id="monthlyCap" placeholder="Enter monthly cap">-->
      <!--              </div>-->
    <!--            </div>-->
    <!--            <div class="col">-->
    <!--              <label for="lifetimeCap" class="form-label">Lifetime Cap</label>-->
    <!--              <div class="input-group">-->
    <!--                <span class="input-group-text"><i class="bi bi-infinity"></i></span>-->
    <!--                <input type="number" class="form-control" id="lifetimeCap" placeholder="Enter lifetime cap">-->
  <!--              </div>-->
<!--            </div>-->
<!--          </div>-->
</div>
</div>
<div class="row">
  <div class="col-6">
    <label class="form-label">Status</label>
    <app-input-switch id="enabled" formControlName="enabled">Enabled</app-input-switch>
  </div>
</div>
@if (isCreate()) {
  <app-offer-goal-setup [goals]="goals" [required]="isAffiliate()" [submitted]="submitted"></app-offer-goal-setup>
}
<div class="text-end">
  <button type="submit" class="btn btn-primary fw-bold" [disabled]="!canUpdate()">
    @if (isCreate()) {
      <span>Create</span>
    }
    @if (!isCreate()) {
      <span>Update</span>
    }
  </button>
</div>
</form>
</div>
</div>
}
